import { Version } from '@libs/shared/interfaces/environment';

export const version: Version = {
  version: '1.0.9',
  buildNumber: '26102901',
};
